import { render } from "./FormModalOrganizations.vue?vue&type=template&id=4403c438&scoped=true"
import script from "./FormModalOrganizations.vue?vue&type=script&lang=js"
export * from "./FormModalOrganizations.vue?vue&type=script&lang=js"

import "./FormModalOrganizations.vue?vue&type=style&index=0&id=4403c438&scoped=true&lang=css"
import "./FormModalOrganizations.vue?vue&type=style&index=1&id=4403c438&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4403c438"]])

export default __exports__